import React from 'react'
import { MenuFirst } from '@ow/comps'
import { useRouteTo } from '@vt/hooks'

const _MenuFirst = (props) => {
  const { menuData, children, appId, ...resolvedProps } = props
  const { transUrlIte } = useRouteTo(null, { appId })
  const menuDataByTrans = (menuData || []).map((nav) => transUrlIte(nav, appId))

  return (
    <MenuFirst {...resolvedProps} menuData={menuDataByTrans || []}>
      {children}
    </MenuFirst>
  )
}
export default _MenuFirst
